<script>
  import Dropdown from "../Common/Dropdown.svelte";
  import { M } from "../external";

  export let onSelect;

  const statusOptions = [
    { label: M.MARK_PENDING, tag: "PENDING" },
    { label: M.MARK_AS_SHIPPED, tag: "SHIPPED" },
    { label: M.MARK_AS_COMPLETED, tag: "COMPLETED" },
    { label: M.MARK_AS_CANCELED, tag: "CANCELED" }
  ];
</script>

<div class="popup-widget-wrapper flex flex-row align-center justify-center">
  <h5>{M.UNARCHIVE_ORDERS_STATUS_LABEL}</h5>
  <Dropdown
    activeItem={{label: M.SELECT_LBL}}
    items={statusOptions}
    on:change={(e) => onSelect(e.detail.selected.tag)} />
</div>
